/**
 * VibeChatContentModel — V5.1+cockpit Vibe Chat content model
 * Source: pact/platform/ai/vibe-chat.md (Cluster T)
 * Plan: plan/ALIGNMENT-DELTAS.md Delta 4
 *
 * Constitutional slots: Messages, Thinking, Reading, Planning, Model, Tool use, Report Cards.
 * FreshCards' AIChatPanel already has Messages. This module exports the slot enum
 * so the panel can opt in incrementally without a rewrite.
 */
export type VibeChatSlot = 'messages' | 'thinking' | 'reading' | 'planning' | 'model' | 'tool' | 'report';

export const VIBE_CHAT_SLOTS: VibeChatSlot[] = [
  'messages',
  'thinking',
  'reading',
  'planning',
  'model',
  'tool',
  'report',
];

/** What FreshCards supports today (in MVP) */
export const VIBE_CHAT_ENABLED_SLOTS: VibeChatSlot[] = ['messages'];

/** Slots to enable in follow-ups (token-friendly: no work yet) */
export const VIBE_CHAT_FUTURE_SLOTS: VibeChatSlot[] = ['thinking', 'reading', 'model', 'report'];
